import React from 'react'

import CustomFieldTypes from './custom-field-types'
import CustomFields from './custom-fields'
import SystemFields from './system-fields'
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll"
import {PopoverAddColumnProps} from "../popover"
import FieldSelector_SearchResults from "../search-results/search-results";

export type PopoverAddFieldsListProps = {
    section                 : string
    searchQuery             : string
    onSelectSection         : func
} & PopoverAddColumnProps

export default class FieldsList extends React.Component<PopoverAddFieldsListProps> {

    renderSearchResult = ()=>{
        return (
            <VScroll className="fields-list" containerClass="ui5-popover-menu p-t-10">
                <FieldSelector_SearchResults
                    searchValue         = {this.props.searchQuery}
                    config              = {this.props.config}
                    columns             = {this.props.columns}
                    selectedFieldIds    = {this.props.selectedFieldIds}
                    onSelect            = {this.props.onToggleColumn}
                />
            </VScroll>
        )
    }

    renderFields = ()=> {
        let component
        switch (this.props.section) {
            case 'new-field':
                component = <CustomFieldTypes {...this.props} />
                break

            case gd.const.fields.groups.CUSTOM_FIELDS:
                component = <CustomFields {...this.props} />
                break

            default:
                component = <SystemFields {...this.props} />
                break
        }

        return (
            <VScroll className="fields-list" containerClass="ui5-popover-menu p-t-10">
                {component}
            </VScroll>
        )
    }

    render() {

        if (this.props.searchQuery.trim().length > 0) {
            return this.renderSearchResult()
        } else {
            return this.renderFields()
        }
    }
}
